/** In-process guard so cashbook writes fail clearly while a backup restore runs. */
let restoreDepth = 0;

export function beginCashbookRestore(): void {
  restoreDepth += 1;
}

export function endCashbookRestore(): void {
  restoreDepth = Math.max(0, restoreDepth - 1);
}

export function isCashbookRestoreInProgress(): boolean {
  return restoreDepth > 0;
}

export function assertCashbookWritesAllowed(): void {
  if (restoreDepth > 0) {
    throw new Error('Cashbook restore in progress — try again when restore finishes');
  }
}
